import { COURIER_TO_BE_CONFIRMED } from 'features/order-tracker/store/sagas/services/helpers/constants';
import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';

export const getDeliveryAccordionAnalytics = (
  title: string,
  expanded: boolean,
  status: common.MilestoneStatus | common.DeliveryStatus | string | undefined,
): string => {
  let deliveryAnalytics;

  if (title === COURIER_TO_BE_CONFIRMED) {
    deliveryAnalytics = `${title} - Accordion ${expanded ? 'closed' : 'opened'}`;
  } else if (status === DELIVERY_STATUSES.ToBeSent) {
    deliveryAnalytics = `Items awaiting dispatch - Accordion ${expanded ? 'closed' : 'opened'}`;
  } else {
    deliveryAnalytics = `${title} - Accordion ${expanded ? 'closed' : 'opened'}`;
  }

  return deliveryAnalytics;
};
